// extracted by mini-css-extract-plugin
export var borderBlink = "MobileCalculator-module--borderBlink--25b09";
export var button = "MobileCalculator-module--button--29323";
export var fadeInAnimation = "MobileCalculator-module--fadeInAnimation--af367";
export var inputsWrapper = "MobileCalculator-module--inputsWrapper--e2ef4";
export var tag = "MobileCalculator-module--tag--9f666";
export var validate = "MobileCalculator-module--validate--f6315";
export var wrapper = "MobileCalculator-module--wrapper--fe993";